import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Index';
import Account from './views/Account/Account';
import Brand from './views/Brands/Brand';
import Brands from './views/Brands/Brands';
import Dispatch from './views/Dispatch/Dispatch';
import Delivery from './views/Deliveries/Delivery';
import Deliveries from './views/Deliveries/Deliveries';
import Login from './views/Account/Login';
import ForgotPassword from './views/Account/ForgotPassword';
import ForgotPasswordReset from './views/Account/ForgotPasswordReset';
import Item from './views/Items/Item';
import ItemCreate from './views/Items/ItemCreate';
import Items from './views/Items/Items';
import ImportExports from './views/ImportsExports/ImportExports';
import KitchenOrder from './views/KitchenOrders/KitchenOrder';
import KitchenOrders from './views/KitchenOrders/KitchenOrders';
import Menu from './views/Menus/Menu';
import Menus from './views/Menus/Menus';
import MenuCreate from './views/Menus/MenuCreate';
import MenuItems from './views/MenuItems/MenuItems';
import Modifier from './views/Modifiers/Modifier';
import Modifiers from './views/Modifiers/Modifiers';
import ModifierCreate from './views/Modifiers/ModifierCreate';
import Order from './views/Orders/Order';
import Orders from './views/Orders/Orders';
import OrderItems from './views/OrderItems/OrderItems';
import ApiKeys from './views/ApiKeys';
import Network from './views/Networks/Network';
import Networks from './views/Networks/Networks';
import OrganizationMenus from './views/OrganizationMenus/OrganizationMenus';
import OrganizationMenu from './views/OrganizationMenus/OrganizationMenu';
import Coupons from './views/Coupons/Coupons';
import CouponCreate from './views/Coupons/CouponCreate';
import Test from './views/Test/Test';

Vue.use(Router);

const parsingId = (route) => ({ id: Number(route.params.id) });

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      props: true,
      meta: {
        title: 'Home',
      },
    },
    {
      path: '/account',
      name: 'account',
      component: Account,
      props: true,
    },
    {
      path: '/dispatch',
      name: 'dispatch',
      component: Dispatch,
      meta: {
        title: 'Dispatch',
        collapseSideBar: true,
      },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      props: true,
      meta: {
        title: 'Login',
        hideSideBar: true,
        hideTopNav: true,
        requiresGuest: true,
      },
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPassword,
      props: true,
      meta: {
        title: 'Forgot Password',
        hideSideBar: true,
        hideTopNav: true,
        requiresGuest: true,
      },
    },
    {
      path: '/reset-password/:token',
      name: 'reset-password',
      component: ForgotPasswordReset,
      props: true,
      meta: {
        title: 'Reset Password',
        hideSideBar: true,
        hideTopNav: true,
        requiresGuest: true,
      },
    },
    {
      path: '/orders',
      name: 'orders',
      component: Orders,
      meta: {
        title: 'Orders',
        related: 'Orders',
        requiresFacility: true,
      },
    },
    {
      path: '/orders/:id',
      name: 'order',
      component: Order,
      meta: {
        title: 'Orders',
        related: 'Orders',
        requiresFacility: true,
      },
    },
    {
      path: '/kitchen-orders',
      name: 'kitchen-orders',
      component: KitchenOrders,
      meta: {
        title: 'Kitchen Orders',
        related: 'KitchenOrders',
      },
    },
    {
      path: '/kitchen-orders/:id',
      name: 'kitchen-order',
      component: KitchenOrder,
      props: parsingId,
      meta: {
        title: 'Kitchen Order',
        related: 'KitchenOrders',
      },
    },
    {
      path: '/deliveries',
      name: 'deliveries',
      component: Deliveries,
      meta: {
        title: 'Deliveries',
        related: 'Deliveries',
        requiresFacility: true,
      },
    },
    {
      path: '/deliveries/:id',
      name: 'delivery',
      component: Delivery,
      props: parsingId,
      meta: {
        title: 'Delivery',
        related: 'Deliveries',
        requiresFacility: true,
      },
    },
    {
      path: '/order-items',
      name: 'order-items',
      component: OrderItems,
      meta: {
        title: 'Order Items',
        related: 'OrderItems',
      },
    },
    {
      path: '/brands',
      name: 'brands',
      component: Brands,
      meta: {
        title: 'Brands',
        related: 'Brands',
      },
    },
    {
      path: '/brands/:id',
      name: 'brand',
      component: Brand,
      props: parsingId,
      meta: {
        title: 'Brand',
        related: 'Brands',
      },
    },
    {
      path: '/menus',
      name: 'menus',
      component: Menus,
      meta: {
        related: 'Menus',
        title: 'Menus',
      },
    },
    {
      path: '/menus/create',
      name: 'menu-create',
      component: MenuCreate,
      meta: {
        title: 'Menu Create',
        related: 'Menus',
      },
    },
    {
      path: '/menus/:id',
      name: 'menu',
      component: Menu,
      props: parsingId,
      meta: {
        related: 'Menus',
        title: 'Menu',
      },
    },
    {
      path: '/menu-items',
      name: 'menu-items',
      component: MenuItems,
      meta: {
        title: 'Menu Items',
        related: 'MenuItems',
      },
    },
    {
      path: '/items',
      name: 'items',
      component: Items,
      meta: {
        title: 'Items',
        related: 'Items',
      },
    },
    {
      path: '/items/create',
      name: 'item-create',
      component: ItemCreate,
      meta: {
        title: 'Items',
        related: 'Items',
      },
    },
    {
      path: '/items/:id',
      name: 'item',
      component: Item,
      props: parsingId,
      meta: {
        title: 'Item',
        related: 'Items',
      },
    },
    {
      path: '/imports',
      name: 'imports',
      component: ImportExports,
      meta: {
        title: 'Imports & Exports',
        related: 'ImportExports',
      },
    },
    {
      path: '/modifiers',
      name: 'modifiers',
      component: Modifiers,
      meta: {
        title: 'Modifiers',
        related: 'Modifiers',
      },
    },
    {
      path: '/modifiers/create',
      name: 'modifier-create',
      component: ModifierCreate,
      meta: {
        title: 'Modifier Create',
        related: 'Modifiers',
      },
    },
    {
      path: '/modifiers/:id',
      name: 'modifier',
      component: Modifier,
      props: parsingId,
      meta: {
        related: 'Modifiers',
        title: 'Modifier',
      },
    },
    {
      path: '/api-keys',
      name: 'api-keys',
      component: ApiKeys,
      meta: {
        title: 'API Keys',
        related: 'Organization',
        requiresOrganization: true,
      },
    },
    {
      path: '/networks',
      name: 'networks',
      component: Networks,
      meta: {
        title: 'Networks',
        related: 'Organization',
        requiresOrganization: true,
      },
    },
    {
      path: '/networks/:id',
      name: 'network',
      component: Network,
      props: parsingId,
      meta: {
        title: 'Network',
        related: 'Organization',
        requiresOrganization: true,
      },
    },
    {
      path: '/organization-menus',
      name: 'organization-menus',
      component: OrganizationMenus,
      meta: {
        title: 'Menus',
        related: 'Organization',
        requiresOrganization: true,
      },
    },
    {
      path: '/organization-menus/:id',
      name: 'organization-menu',
      component: OrganizationMenu,
      props: parsingId,
      meta: {
        title: 'Menu',
        related: 'Organization',
        requiresOrganization: true,
      },
    },
    {
      path: '/coupons',
      name: 'coupons',
      component: Coupons,
      meta: {
        title: 'Coupons',
        related: 'Coupons',
      },
    },
    {
      path: '/coupons/create',
      name: 'coupon-create',
      component: CouponCreate,
      meta: {
        title: 'Create Coupon',
        related: 'Coupons',
      },
    },
    {
      path: '/test',
      name: 'test',
      component: Test,
      props: true,
    },
  ],
});

// Athentication guard
router.beforeEach((to, from, next) => {
  const authenticated = $cookies.isKey('zdm_authentication');
  const guestRequired = to.matched.some((record) => record.meta.requiresGuest);
  const role = $cookies.get('zdm_role');

  // Fix impaired state
  if (!authenticated && role) {
    $cookies.remove('zdm_role');
  } else if (authenticated && !role) {
    // Sign out user without access
    $cookies.remove('zdm_authentication');
    return;
  }

  // Guest required - redirect authed users to homepage
  if (guestRequired && authenticated) {
    next('/');
  }

  // Redirect to authentication

  if (!guestRequired && !authenticated) {
    next('/login');
  }

  // Guest required - allow non authed users to proceed
  if (guestRequired && !authenticated) {
    next();
  }

  // Facility admin required
  if (to.matched.some((record) => record.meta.requiresFacility)) {
    if (!['facility_admin', 'admin'].includes(role)) {
      next('/');
    } else {
      next();
    }
    return;
  }

  // Organization admin required - this will be checked in the component
  // since we need access to the store to check organizationAdmin getter
  if (to.matched.some((record) => record.meta.requiresOrganization)) {
    // Allow admin role, organization_admin role, and portal role to access
    // The component will handle the actual organization admin check
    if (!['admin', 'facility_admin', 'portal'].includes(role)) {
      next('/');
    } else {
      next();
    }
    return;
  }

  next();
});

export default router;
